import './api/PartnerAPI.js';
import './entities/Bank.js';
import './entities/Chancellery.js';
import './entities/ChancenSchule.js';
import './entities/Club.js';
import './entities/Foundation.js';
import './entities/Fundingpot.js';
import './entities/FundingpotFunding.js';
import './entities/GovernmentOffice.js';
import './entities/Institute.js';
import './entities/Institution.js';
import './entities/MediaCompany.js';
import './entities/NonProfitOrganisation.js';
import './entities/Office.js';
import './entities/Organisation.js';
import './entities/Partner.js';
import './entities/Politic.js';
import './entities/PublicPlace.js';
import './entities/School.js';
import './entities/SubDivision.js';
import './entities/Messe.js';
import './entities/University.js';
import './entities/aspects/PartnerActiveAspect.js';
import './entities/aspects/PartnerAspect.js';
